<div class="flex-direction-column gap-15">
  <div class="flex gap-15">
    <div [ngClass]="{ 'card-selecionado': midiaSelcionada.foto }" role="button" tabindex="0" (click)="selecionarMidia(1)" (keydown.enter)="selecionarMidia(1)" class="flex center-center card-midia cursor-pointer">
      @if (midiaSelcionada.foto){
        <img src="./assets/icones/foto-primary.svg" alt="Foto selecionada">
      }
      @else {
        <img src="./assets/icones/foto.svg" alt="Foto">
      }
    </div>
    <div [ngClass]="{ 'card-selecionado': midiaSelcionada.video }" role="button" tabindex="0" (click)="selecionarMidia(2)" (keydown.enter)="selecionarMidia(2)" class="flex center-center card-midia cursor-pointer">
      @if (midiaSelcionada.video){
        <img src="./assets/icones/video-primary.svg" alt="Vídeo selecionado">
      }
      @else {
        <img src="./assets/icones/video.svg" alt="Vídeo">
      }
    </div>
    <div [ngClass]="{ 'card-selecionado': midiaSelcionada.document }" role="button" tabindex="0" (click)="selecionarMidia(3)" (keydown.enter)="selecionarMidia(3)" class="flex center-center card-midia cursor-pointer">
      @if (midiaSelcionada.document){
        <img src="./assets/icones/document-primary.svg" alt="Documento selecionado">
      }
      @else {
        <img src="./assets/icones/document.svg" alt="Documento">
      }
    </div>
    <div [ngClass]="{ 'card-selecionado': midiaSelcionada.map }" role="button" tabindex="0" (click)="selecionarMidia(4)" (keydown.enter)="selecionarMidia(4)" class="flex center-center card-midia cursor-pointer">
      @if (midiaSelcionada.map){
        <img src="./assets/icones/map-primary.svg" alt="Localização selecionada">
      }
      @else {
        <img src="./assets/icones/map.svg" alt="Localização">
      }
    </div>
  </div>

  @if (selecionouMidia) {
    <div class="cursor-pointer" role="button" tabindex="0" (click)="anexar()" (keydown.enter)="anexar()">
      <img src="./assets/icones/anexo.svg" alt="Anexar arquivo">
    </div>
    <input
      #fileInput
      type="file"
      (change)="buscarArquivo($event)"
      multiple
      style="display: none"
    />
  }
</div>
